<template>
  <UiDialog
    class="PreviewButton"
    :close-scrim="false"
  >
    <template #trigger>
      <UiIcon
        :title="$t('PreviewButton.title')"
        value="mdi:eye-outline"
        class="ToolbarButton"
      ></UiIcon>
    </template>

    <template #contents>
      <div v-html="editor.getHTML()"></div>
    </template>

    <template #footer="{ close }">
      <button
        type="button"
        class="ui-native --main"
        @click="close"
      >{{ $t('PreviewButton.Close') }}</button>
    </template>
  </UiDialog>
</template>

<script>
import useI18n from '@/modules/i18n/mixins/useI18n.js';
import { UiIcon, UiDialog, UiInput } from '@/modules/ui/components';

export default {
  components: {
    UiIcon,
    UiDialog,
    UiInput,
  },

  mixins: [useI18n],

  props: {
    editor: {
      type: Object,
      required: true,
    },
  },

  i18n: {
    en: {
      'PreviewButton.title': 'Preview',
      'PreviewButton.Close': 'Close',
    },
    es: {
      'PreviewButton.title': 'Vista previa',
      'PreviewButton.Close': 'Cerrar',
    },
    de: {
      'PreviewButton.title': 'Vorschau',
      'PreviewButton.Close': 'Schließen',
    },
    fr: {
      'PreviewButton.title': 'Aperçu',
      'PreviewButton.Close': 'Fermer',
    },
    it: {
      'PreviewButton.title': 'Anteprima',
      'PreviewButton.Close': 'Chiudere',
    },
    pt: {
      'PreviewButton.title': 'Pré-visualização',
      'PreviewButton.Close': 'Fechar',
    },
  },
};
</script>

<style lang="scss">
.PreviewButton {
  a {
    color: -webkit-link;
    text-decoration: underline;

    &:hover {
      background: #bfe6ff;
    }
  }
}
</style>